import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import { Consultant } from '../../interfaces/Consultant';
import { ConsultantActionCreators } from '../../store/consultants';
import { useEditorStyles, useStackClassName } from '../Styles/Editor';
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Field } from '@fluentui/react-components';
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { onFormatDate } from '../Tools/converters';

interface DateRange {
    startDate: Date | null,
    endDate: Date | null,
}

export const ConsultantsActivityPeriodesEditor = () => {
    // All data needed for edition should be loaded before calling the editor
    const consultantActivityPeriodesEdit = useSelector<ApplicationState, Consultant | null>((state: ApplicationState) => state.consultantsState.consultantActivityPeriodesEdit);
    // Gen hooks
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const styles = useEditorStyles();
    // Fields
    const [consultantActivityPeriodes, setConsultantActivityPeriodes] = React.useState<DateRange[]>([]);
    const [startDate, setStartDate] = React.useState<Date | null>(null);
    const [endDate, setEndDate] = React.useState<Date | null>(null);
    const [newRangeAllowed, setNewRangeAllowed] = React.useState(false);
    // Form validation
    const [isSubmitValid/*, setSubmitValid*/] = React.useState(false);

    React.useEffect(() => {
        if (consultantActivityPeriodesEdit && consultantActivityPeriodesEdit.consultantActivityPeriodes) {
            const r: DateRange[] = [];
            let openRange = false;
            consultantActivityPeriodesEdit.consultantActivityPeriodes.map(e => {
                const startDate = e.dateDebut ? new Date(e.dateDebut) : null;
                const endDate = e.dateFin ? new Date(e.dateFin) : null;
                if (!e.dateDebut || !e.dateFin) {
                    openRange = true;
                }
                r.push({ startDate, endDate });
            });
            setConsultantActivityPeriodes(r);
            setNewRangeAllowed(!openRange);
        }
    }, [consultantActivityPeriodesEdit]);


    if (!consultantActivityPeriodesEdit) {
        return null;
    }

    const submit = () => {
        //    const c: Consultant = {
        //        consultantid: consultantActivityPeriodesEdit && consultantActivityPeriodesEdit.consultantid ? consultantActivityPeriodesEdit.consultantid : null,
        //        displayName: displayName,
        //        email: email,
        //        o365id: o365id,
        //        isActive: isActive,
        //        isAdmin: isAdmin,
        //        canEnterDocuments: canEnterDocuments,
        //        canManageConsultantDocuments: canManageConsultantDocuments,
        //        receiveNotification: receiveNotification,
        //        receiveInvoiceEmails: receiveInvoiceEmails,
        //        canEnterTimeSheet: canEnterTimeSheet,
        //        companyName: companyName,
        //        vat: vat,
        //        iban: iban,
        //        address: address,
        //        address2: address2,
        //        address3: address3,
        //        postalCode: postalCode,
        //        city: city,
        //        country: country,
        //    };

        //    TokenHelper.GetToken(instance, teamsState)
        //        .then(token => {
        //            if (token !== null) {
        //                const toastId = (Math.random() + 1).toString(36).substring(7);
        //                dispatchToast(
        //                    <Toast appearance="inverted">
        //                        <ToastTitle>"Saving consultant..."</ToastTitle>
        //                    </Toast>,
        //                    { intent: "info", timeout: -1, position: "top-end", toastId: toastId }
        //                );
        //                fetch("api/Consultants/" + (consultantActivityPeriodesEdit && consultantActivityPeriodesEdit.consultantid !== null ? consultantActivityPeriodesEdit.consultantid : ""), {
        //                    method: consultantActivityPeriodesEdit && consultantActivityPeriodesEdit.consultantid === null ? "POST" : "PUT",  // if customerid exist, path
        //                    headers: {
        //                        "Content-Type": "application/json",
        //                        authorization: "bearer " + token,
        //                    },
        //                    body: JSON.stringify(c),
        //                    mode: "cors",
        //                    cache: "default",
        //                })
        //                    .then(response => {
        //                        if (response.status === 200) {
        //                            updateToast({
        //                                content: (
        //                                    <Toast appearance="inverted">
        //                                        <ToastTitle>Consulant saved</ToastTitle>
        //                                    </Toast>
        //                                ),
        //                                intent: "success",
        //                                toastId,
        //                                timeout: 5000,
        //                            });
        //                            return response.json() as Promise<Consultant>;
        //                        }
        //                        else {
        //                            updateToast({
        //                                content: (
        //                                    <Toast appearance="inverted">
        //                                        <ToastTitle action={
        //                                            <ToastTrigger>
        //                                                <Link>Dismiss</Link>
        //                                            </ToastTrigger>
        //                                        }>Consulant save failed</ToastTitle>
        //                                    </Toast>
        //                                ),
        //                                intent: "error",
        //                                toastId,
        //                                timeout: 10000,
        //                            });
        //                        }
        //                    })
        //                    .then(data => {
        //                        if (data) dispatch(ConsultantActionCreators.patchConsultantEdition(data));
        //                        dispatch(ConsultantActionCreators.requestConsultantActivityPeriodesEdition(null));
        //                    });
        //            }
        //        });
    };

    return <Dialog
        open
        modalType="modal">
        <DialogSurface>
            <DialogBody>
                <DialogTitle>{"Edit consultant " + consultantActivityPeriodesEdit.displayName + " activity periodes"}</DialogTitle>
                <DialogContent>
                    <form
                        onSubmit={() => {
                            dispatch(ConsultantActionCreators.requestConsultantActivityPeriodesEdition(null));
                        }}
                        className={useStackClassName()}
                        autoComplete="off"
                    >
                        {
                            consultantActivityPeriodes.map(e =>
                                <div className={styles.onSingleLine}>
                                    <div className={styles.field50}>
                                        <Field label={t('Start')} className={styles.fluid}
                                            required
                                        >
                                            <DatePicker className={styles.fluid}
                                                onSelectDate={(date: Date | null | undefined) => {/* setStartDate(date === undefined ? null : date);*/ }}
                                                value={e.startDate === null ? undefined : e.startDate}
                                                formatDate={onFormatDate}
                                                placeholder={t('SelectStartDate')}
                                            />
                                        </Field>
                                    </div>
                                    <div className={styles.field50}>
                                        <Field label={t('End')} className={styles.fluid}>
                                            <DatePicker className={styles.fluid}
                                                onSelectDate={(date: Date | null | undefined) => { /*setEndDate(date === undefined ? null : date);*/ }}
                                                value={e.endDate === null ? undefined : e.endDate}
                                                formatDate={onFormatDate}
                                                placeholder={t('SelectEndDate')}
                                            />
                                        </Field>
                                    </div>
                                </div>
                            )
                        }
                        {newRangeAllowed &&
                            <div className={styles.onSingleLine}>
                                <div className={styles.field50}>
                                    <Field label={t('Start')} className={styles.fluid}
                                        required
                                    >
                                        <DatePicker className={styles.fluid}
                                            onSelectDate={(date: Date | null | undefined) => { setStartDate(date === undefined ? null : date); }}
                                            value={startDate === null ? undefined : startDate}
                                            formatDate={onFormatDate}
                                            placeholder={t('SelectStartDate')}
                                        />
                                    </Field>
                                </div>
                                <div className={styles.field50}>
                                    <Field label={t('End')} className={styles.fluid}>
                                        <DatePicker className={styles.fluid}
                                            onSelectDate={(date: Date | null | undefined) => { setEndDate(date === undefined ? null : date); }}
                                            value={endDate === null ? undefined : endDate}
                                            formatDate={onFormatDate}
                                            placeholder={t('SelectEndDate')}
                                        />
                                    </Field>
                                </div>
                            </div>
                        }
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => dispatch(ConsultantActionCreators.requestConsultantActivityPeriodesEdition(null))}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        onClick={() => submit()}
                        type="submit"
                        form="my-form-id"
                        appearance="primary"
                        disabled={!isSubmitValid}
                    >
                        {t("Save")}
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>;
};